import script from "./i-price-config.vue?vue&type=script&lang=tsx&setup=true"
export * from "./i-price-config.vue?vue&type=script&lang=tsx&setup=true"

import "./i-price-config.vue?vue&type=style&index=0&id=0aefa8da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aefa8da"]])

export default __exports__